import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faUsers } from '@fortawesome/free-solid-svg-icons';
import { faComment } from '@fortawesome/free-regular-svg-icons';

export const GlobalMedicNav = ({active}) => {

    const navigateTo = useNavigate();

    return (
        <div className="global-medic-nav">
            <button
                className={`global-nav-button ${active === 'disc' && "active"}`}
                onClick={() => {
                    navigateTo("/globalmedic/discussion")
                }}
            >
                <FontAwesomeIcon icon={faComment} />
                <span className="g-n-b-label">Global Discussions</span>
            </button>
            <button
                className={`global-nav-button ${active === 'blog' && "active"}`}
                onClick={() => {
                    navigateTo("/globalmedic/blogposts")
                }}
            >
                <FontAwesomeIcon icon={faBookOpen} />
                <span className="g-n-b-label">Blog Posts</span>
            </button>
            <button
                className={`global-nav-button ${active === 'comm' && "active"}`}
                onClick={() => {
                    navigateTo("/globalmedic/communities")
                }}
            >
                <FontAwesomeIcon icon={faUsers} />
                <span className="g-n-b-label">Global Communities</span>
            </button>
        </div>
    )
}